import { useState, useEffect, useRef } from "react";
import hm1 from "../assets/kylpyhuone.png";
import hm2 from "../assets/kylpyhuone2.png";

const RotatingPhotos = () => {
  const images = [hm1, hm2];
  const [current, setCurrent] = useState(0);
  const intervalRef = useRef(null);

  const startAutoRotate = () => {
    intervalRef.current = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 9000);
  };

  useEffect(() => {
    startAutoRotate();
    return () => clearInterval(intervalRef.current);
  }, [images.length]);

  const goNext = () => {
    clearInterval(intervalRef.current);
    setCurrent((prev) => (prev + 1) % images.length);
    startAutoRotate();
  };

  const goPrev = () => {
    clearInterval(intervalRef.current);
    setCurrent((prev) =>
      prev === 0 ? images.length - 1 : prev - 1
    );
    startAutoRotate();
  };

  return (
    <div className="rotating-photos-container">
      {images.map((img, index) => (
        <div
          key={index}
          className={`rotating-photo ${index === current ? "active" : ""}`}
          style={{ backgroundImage: `url(${img})` }}
        ></div>
      ))}
      <div className="photo-controls">
        <button onClick={goPrev} className="arrow-btn"><i className="fa-solid fa-arrow-left"></i></button>
        <button onClick={goNext} className="arrow-btn"><i className="fa-solid fa-arrow-right"></i></button>
      </div>
    </div>
  );
};

export default RotatingPhotos